<template>
  <div ref="chart" class="tabs" v-show="position.show">
    <div :style="{ width: `${position.w}px`, height: `${position.y}px`, paddingTop: '5px' }">
      <div
        :style="{
          height: `${option.style.height}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: `${option.position}`
        }"
      >
        <div
          :style="{
            lineHeight: `${option.style.height}px`,
            paddingLeft: `${option.style.paddingLeft}px`,
            display: 'flex',
            alignItems: 'center'
          }"
        >
          <span
            class="tab-header"
            v-for="(item, index) in option.tabList"
            :key="item.key"
            :title="item.name"
            :style="{
              fontSize: `${option.style.default.fontSize}px`,
              fontWeight:
                option.activeIndex === index
                  ? `${option.style.active.fontWeight}`
                  : `${option.style.default.fontWeight}`,
              color: option.activeIndex === index ? option.style.active.color : option.style.default.color,
              // width: `${option.style.width}px`,
              marginRight: `${option.style.marginRight}px`,
              backgroundImage:
                option.activeIndex === index
                  ? `url(${option.style.active.backgroundImage})`
                  : `url(${option.style.default.backgroundImage})`,
              backgroundSize: '100% 100%',
              // backgroundColor: 'rgba(177,190,200,0.8)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              borderBottom: option.activeIndex === index ? `2px solid ${option.style.active.color}` : ''
            }"
            @click="handleTabClick(index)"
          >
            {{ item.name }}
          </span>
        </div>
        <a-range-picker
          v-model="option.cTime"
          @change="onChange"
          class="picker"
          :locale="locale"
          :style="
            `--my-color: ${option.style.pickerColor};--my-size: ${option.style.pickerSize}px;--my-background: ${option.style.pickerBackground};`
          "
        >
          <a-icon slot="suffixIcon" type="calendar" :style="{ color: `${option.style.pickerIconColor}` }" />
        </a-range-picker>
      </div>
    </div>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
export default {
  // 导航配置组件
  name: 'DatePicker',
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
    // viewType: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      locale
    }
  },
  filters: {},
  computed: {},
  mounted() {
    this.getTime()
  },
  methods: {
    handleTabClick(index) {
      this.option.activeIndex = index
      this.getTime()
      this.$emit('changeDate', this.option.cTime)
    },
    onChange(date, dateString) {
      console.log(date, dateString)
      this.option.cTime = dateString
      this.option.activeIndex = null
      this.$emit('changeDate', dateString)
    },
    getTime() {
      if (this.option.activeIndex === 0) {
        this.option.cTime = this.getCurrentWeekDates()
      } else if (this.option.activeIndex === 1) {
        this.option.cTime = this.getCurrentMonthDates()
      } else if (this.option.activeIndex === 2) {
        this.option.cTime = this.getCurrentYearDates()
      } else {
        this.option.cTime = []
      }
    },
    //周
    getCurrentWeekDates() {
      let currentDate = new Date()
      let currentDay = currentDate.getDay() // 获取当前是星期几 (0 是周日, 1 是周一, ..., 6 是周六)
      let diff = currentDate.getDate() - currentDay + (currentDay === 0 ? -6 : 1) // 获取本周的第一天 (周一)

      let weekStartDate = new Date(currentDate.setDate(diff))
      let weekEndDate = new Date(currentDate.setDate(diff + 6)) // 本周的最后一天 (周日)

      // 格式化日期为 'YYYY-MM-DD'
      let startDateFormatted = this.formatDate(weekStartDate)
      let endDateFormatted = this.formatDate(weekEndDate)

      return [startDateFormatted, endDateFormatted]
    },
    //月
    getCurrentMonthDates() {
      let currentDate = new Date()
      let year = currentDate.getFullYear()
      let month = currentDate.getMonth() // 获取当前月份，注意月份从 0 开始 (0 是一月, 1 是二月, ..., 11 是十二月)

      // 计算本月的第一天和下个月的第一天
      let firstDay = new Date(year, month, 1)
      let nextMonthFirstDay = new Date(year, month + 1, 1)

      // 计算本月最后一天
      let lastDay = new Date(nextMonthFirstDay.getTime() - 24 * 60 * 60 * 1000)

      // 格式化日期为 'YYYY-MM-DD'
      let startDateFormatted = this.formatDate(firstDay)
      let endDateFormatted = this.formatDate(lastDay)

      return [startDateFormatted, endDateFormatted]
    },
    //年
    getCurrentYearDates() {
      let currentDate = new Date()
      let year = currentDate.getFullYear()

      // 计算本年的第一天和最后一天
      let firstDay = new Date(year, 0, 1) // 一月的第一天
      let lastDay = new Date(year, 11, 31) // 十二月的最后一天

      // 格式化日期为 'YYYY-MM-DD'
      let startDateFormatted = this.formatDate(firstDay)
      let endDateFormatted = this.formatDate(lastDay)

      return [startDateFormatted, endDateFormatted]
    },
    formatDate(date) {
      let year = date.getFullYear()
      let month = ('0' + (date.getMonth() + 1)).slice(-2)
      let day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped lang="less">
.tabs {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.tab-header {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
::v-deep .ant-input {
  background: var(--my-background);
  color: var(--my-color);
  font-size: var(--my-size);
  border: none;
  width: 100%;
}
// .picker {
//   color: var(--my-color) !important;
//   ::v-deep .ant-input {
//     color: var(--my-color) !important;
//   }
//   /* 注意：Less 本身不支持 CSS 变量，但你可以使用 CSS 片段或混合（mixin）来间接使用 */
// }
</style>
